// lbl.mission
export const mission = {
    you_have: 'You have',
    point_unit: 'plankton',
    title_mission: 'Check in to get planktons',
    detail: 'Terms and conditions',
    checked: 'You checked in {0} day',
    date: 'Day ',
    btn_title_checkin: 'Check in',
    btn_msg_checkin: 'Click here to check in',
    title_success: 'Yay!',
    msg_success: "You've completed the mission",
    mission: 'Mission',
    coming_soon: 'Mission is coming soon',

    title_mission_list: 'Mission',
    play: 'Play',
    play_game: 'Play',
    play_success: 'Played',
    game_match_error: 'Something went wrong, please try again',
    survey: 'Join now',
    survey_success: 'Played',
    detail_condition: 'Terms & conditions',
    btn_play: 'Play !',
    start_game: 'Start game',
    match_tc_title: 'Flip and Pair',
    btn_survey: 'Play !',
    detail_coming_soon: 'Coming soon!',

    game_confirm: {
        title: 'How to play?',
        msg: 'Swim and dodge all obstacles',
        btn: 'OK',
    },
    game_puzzle_confirm: {
        title: 'How to play',
        msg: 'Begin the adventure by arranging the aquatic animals into rows of 3 to reach {0} points.',
        btn: 'Play',
        close: 'Close'
    },
    play_win: 'You completed the mission',
    scroll_down: 'Please Scroll Down',

    mission_transaction: 'Transaction missions',
    mission_other: 'Other missions',
    mission_comingsoon: 'Coming soon',

    transaction_detail: 'Details',
    transaction_condition: 'Conditions',
    btn_transaction_confirm: 'Join now',
    btn_join: 'Join now',
    month: 'Month',
    make_success: 'Completed : ',
    timeCountDown: '',
    day: 'days left',
    max_qty: 'The number of users exceeded the limit'
};
